export enum AssociatedBy {
  ContractManager = 'contract-manager',
  Domain = 'domain',
  Intranet = 'intranet',
  SSO = 'sso',
  Invite = 'invite'
}
